import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss']
})
export class PostComponent implements OnInit {

  @ViewChild('sectionSubscribe', { static: true }) sectionSubscribeDiv: ElementRef;

  comentariosForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
    comentario: new FormControl('', [Validators.required, Validators.minLength(20)])
  });

  film: any;
  idPost: string;
  post: any;
  titulo: string;
  imagen: string;
  fecha: string;
  contenido: string;
  comentarios: any;
  url: any;
  vdo: string;
  urlSafe: SafeResourceUrl;
  constructor(private blogSvc: BlogService,
              private route: ActivatedRoute,
              private sanitizer: DomSanitizer
) { }

  ngOnInit(): void {
    this.scrollToSubscribe();
    const id = this.route.snapshot.paramMap.get('id');
    this.idPost = id;
    this.blogSvc.PostById(id)
                .subscribe(res => {
                  this.post = res;
                  this.titulo = this.post.titulo;
                  this.imagen = this.post.imagen;
                  this.film = this.post.video;
                  this.url = this.post.imagen;
                  this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
                  this.fecha = this.post.creado;
                  this.contenido = this.post.contenido;
                  //console.log(this.url);

                  this.blogSvc.comentsPostById(id)
                              .subscribe(coment => {
                                this.comentarios = coment;
                              });
                });
  }

  scrollToSubscribe(){
    this.sectionSubscribeDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  comentar(coment: any){
    this.blogSvc.sendComment(this.idPost, coment.email, coment.comentario)
                .then(cmt => {
                  Swal.fire('Comentario cargado correctamente');
                });
  }


}
